import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Utils
import { translation } from '../../../utils/helpers'

// Actions
import { getEmployee } from '../../../actions/employees'
import { getCustomerContact } from '../../../actions/customers'
import { getAdminChain } from '../../../actions/chains'
import { getPartnerContact } from '../../../actions/workProviderContact'
import { getShopOwner } from '../../../actions/shopowners'
import { createBaseUser } from '../../../actions/users'

// import styles
import './index.scss'
import Col from '../../elements/col'
import Panel from '../../elements/panel'
import Text from '../../elements/text'
import Button from '../../elements/button'

class CreateUser extends Component {

  constructor (props) {
    super(props)
    this.default = {
      UserId: 0,
      Name: '',
      Email: '',
      Confirmed: false,
      CustomerId: this.props.customerID && this.props.customerID,
      ChainId: this.props.chainID && this.props.chainID,
      WorkProviderId: this.props.wpID && this.props.wpID,
      ResendActivationMail: false,
      UserType: 0
    }
    this.state = {
      UserId: 0,
      Name: '',
      Email: '',
      Confirmed: false,
      CustomerId: this.props.customerID && this.props.customerID,
      ChainId: this.props.chainID && this.props.chainID,
      WorkProviderId: this.props.wpID && this.props.wpID,
      ResendActivationMail: false,
      UserType: 0
    }

    this.updateUser = this.updateUser.bind(this)
    this.getInfo = this.getInfo.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentDidMount () {
    this.updateUser(this.props.user)
  }

  componentWillReceiveProps (next) {
    if (next !== this.props) {
      this.updateUser(next.user)
    }
  }

  updateUser (user) {
    if (user) {
      if (this.state.UserId !== user.UserId && user.UserId > 0) {
        if (this.props.isEmployee) {
          this.props.getEmployee(user.UserId).then(res => {
            user = res.data
            this.setState({
              UserId: user.UserId,
              Name: user.Name,
              Email: user.Email,
              Confirmed: user.Confirmed,
              UserType: user.UserType
            })
          })
        } else if (this.props.isContact) {
          this.props.getCustomerContact(user.UserId).then(res => {
            user = res.data
            this.setState({
              UserId: user.UserId,
              Name: user.Name,
              Email: user.Email,
              Confirmed: user.Confirmed,
              CustomerId: user.CustomerId,
              UserType: user.UserType
            })
          })
        } else if (this.props.isChainAdmin) {
          this.props.getAdminChain(user.UserId).then(res => {
            user = res.data
            this.setState({
              UserId: user.UserId,
              Name: user.Name,
              Email: user.Email,
              Confirmed: user.Confirmed,
              ChainId: user.ChainId,
              UserType: user.UserType
            })
          })
        } else if (this.props.isWPContact) {
          this.props.getPartnerContact(user.UserId).then(res => {
            user = res.data
            this.setState({
              UserId: user.UserId,
              Name: user.Name,
              Email: user.Email,
              Confirmed: user.Confirmed,
              WorkProviderId: user.WorkProviderId,
              UserType: user.UserType
            })
          })
        } else if (this.props.isShopOwner) {
          this.props.getShopOwner(user.UserId).then(res => {
            user = res.data
            this.setState({
              UserId: user.UserId,
              Name: user.Name,
              Email: user.Email,
              Confirmed: user.Confirmed,
              UserType: user.UserType
            })
          })
        }
      }

      this.setState({
        UserId: user.UserId,
        Name: user.Name,
        Email: user.Email,
        Confirmed: user.Confirmed,
        CustomerId: user.CustomerId,
        ChainId: user.ChainId,
        WorkProviderId: user.WorkProviderId,
        UserType: user.UserType
      })
    } else {
      this.setState({
        ...this.default
      })
    }
  }

  createUser (resend = false) {
    const errorMessage = (error, userType) => {
      let messageText = ''
      if (error < 5) {
        switch (userType) {
          case 'employee':
            messageText += translation('16334')
            break
          case 'contact':
            messageText += translation('16340')
            break
          case 'chainAdmin':
            messageText += translation('17948')
            break
          case 'wpContact':
            messageText += translation('17950')
            break
          case 'shopOwner':
            messageText += translation('17953')
            break
          default:
            break
        }
      }
      if (messageText !== '') messageText += ' '
      switch (error) {
        case 1:
          messageText += translation('16329')
          break
        case 2:
          messageText += translation('16336')
          break
        case 3:
          messageText += translation('16335')
          break
        case 4:
          messageText += translation('16338')
          break
        case 5:
          messageText += translation('16337')
          break
        case 6:
          messageText += translation('1794')
          break
        default:
          break
      }
      messageText += '<br>'
      return messageText
    }
    let state = this.state
    if (resend) state.ResendActivationMail = true

    let userType = this.props.isEmployee ? 'employee'
    : this.props.isContact ? 'contact'
    : this.props.isChainAdmin ? 'chainAdmin'
    : this.props.isWPContact ? 'wpContact'
    : this.props.isShopOwner ? 'shopOwner' : ''
    state.UserType = this.props.isEmployee ? 5
    : this.props.isContact ? 9
    : this.props.isChainAdmin ? 2
    : this.props.isWPContact ? 10
    : this.props.isShopOwner ? 3 : 0

    this.props.createBaseUser(state).then(res => {
      this.props.onSuccess(res.data)
    }).catch(err => {
      let errors = err.response.data
      if (Array.isArray(errors)) {
        let message = errors.map(error => errorMessage(error, userType))
        window.toastr.error(message, translation('216'))
      } else {
        window.toastr.error(errors, translation('216'))
      }
    })
  }

  render () {
    const onBlur = () => {
      if (this.state.UserId > 0) {
        this.createUser()
      }
    }

    return (
      <div className='create-user--screen'>
        <Col>
          <Panel title={this.props.title}>
            <Text labelText={translation('30')} name='Name' value={this.state.Name || ''} onChange={this.onInputChange} onBlur={onBlur} />
            <Text labelText={translation('1052')} name='Email' value={this.state.Email || ''} onChange={this.onInputChange} onBlur={onBlur} />
            {(this.state.Confirmed !== true && this.state.UserId > 0) && <Button style='link' labelText={translation('16319')} onClick={() => this.createUser(true)} />}
          </Panel>
        </Col>
      </div>
    )
  }

  onInputChange (e) {
    let name = e.target.name
    let value = e.target.value

    this.setState({
      [name]: value
    })
  }

  getInfo () {
    return {
      Name: this.state.Name,
      Email: this.state.Email
    }
  }
}

CreateUser.prototypes = {
  title: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  return {}
}

export default connect(mapStateToProps, {
  getEmployee,
  getCustomerContact,
  getAdminChain,
  getPartnerContact,
  getShopOwner,
  createBaseUser
}, null, { withRef: true })(CreateUser)




// WEBPACK FOOTER //
// ./src/app/shared/components/CreateUser/index.js